import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'
import '$styles/vue-select-theme.scss'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('v-select', vSelect)
})
